import { kinboxUrl } from "@/App"
import { updateClient } from "@/hooks/useClient"
import { decodeBase64ToJson } from "@/lib/utils"
import { store } from "@/stores/stores"
import { useEffect } from "react"
import { useSearchParams, useNavigate } from "react-router"

interface AuthKinboxProps {
  //   children: React.ReactNode
}

function AuthKinbox(props: AuthKinboxProps) {
  let [searchParams] = useSearchParams()
  const navigate = useNavigate()
  useEffect(() => {
    const logout = () => {
      console.log("logout")
      store.session.actions.logout()
      window.location.href = kinboxUrl
    }

    try {
      const decoded = decodeBase64ToJson(searchParams.get("tokenized"))
      if (decoded && decoded.token && decoded.workspaceId) {
        store.session.actions.saveKinboxAuthSession({
          workspace: {
            id: decoded.workspaceId,
            name: decoded.workspaceName,
            slug: decoded.slug,
            avatar: decoded.workspaceAvatar,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            token: decoded.token,
          },
          user: {
            id: decoded.userId,
            name: decoded.userName,
            email: decoded.userEmail,
            avatar: decoded.userAvatar,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          } as any,
        })
        setTimeout(() => {
          updateClient()
          navigate("/scenarios", {
            replace: true,
          })
        }, 100)
      } else {
        logout()
      }
    } catch (error) {
      logout()
    }
  }, [])

  return <>{null}</>
}

export default AuthKinbox
